import React, { useState, useEffect, useRef } from 'react'
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Box from '@material-ui/core/Box';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';


import { useStyles, StyledTableCell, StyledTableRow, BootstrapInput } from './assets/EnergyStyles'
import { EnergyUnit, EnergyTypes, IsEnergyScreen } from '../../services/bunkermaster/Settings'
import EnergyConversionService from '../../services/bunkermaster/EnergyConversionService';
import { VpsGravityType } from '../../services/bunkermaster/FuelMath';


function EnergyConversion(props) {
    const classes = useStyles();
    const initialState = {
        energyUnit: EnergyUnit.MJ_KG,
        gravityType: VpsGravityType.Density,
        energyValue: '',
        gravityValue: ''
    };

    const [
        { energyUnit, gravityType, energyValue, gravityValue },
        setState] = useState(initialState);

    const [calcEnrgyUnits, setCalcEnrgyUnits] = useState({});
    const [errs, setErrs] = useState([]);
    const [validate, setValidate] = React.useState({ msg: "", textstyle: "userinfo" })
    const onChangeHandler = (name, value) => {
        setState(prevState => ({ ...prevState, [name]: value }));

        if (gravityType === 1 || gravityType === 2 || gravityType === 3) {
            let vali = validate;
            vali["msg"] = "";
            setValidate({ ...validate, ...vali });
        }
    }

    const onConvertHandle = () => {

        IsEnergyScreen.flag = true;
        EnergyConversionService.errors = [];
        const calcEnrgyUnits = EnergyConversionService.ConvertEnergy({
            energyUnit,
            energyValue,
            gravityType,
            gravityValue,
        });
        if (EnergyConversionService.errors.length > 0) {
            const errs = EnergyConversionService.errors.join("<br>");
            setErrs(errs);
        } else {
            setErrs("");
        }
        IsEnergyScreen.flag = false;
        // if (calcEnrgyUnits.energyUnit === 1 && calcEnrgyUnits.gravityType === 1) {
        //     setCalcEnrgyUnits({ ...calcEnrgyUnits });
        // }
        setCalcEnrgyUnits({ ...calcEnrgyUnits });

    }


    const onReset = () => {
        setState({ ...initialState });
        setCalcEnrgyUnits({});
        setErrs("");
    }

    return (
        <>
            <Grid container spacing={3}>
                <Grid item xs={12} md={8}>

                    <FormControl variant="outlined" className={classes.formControl}>

                        <Box component="div" className="bunkarinput">
                            <Select
                                labelId="outlined-label"
                                className="mr20 bunkerselect custom-style2"
                                value={energyUnit}
                                onChange={(e) => onChangeHandler("energyUnit", e.target.value)} >
                                <MenuItem value={1}> Energy in MJ/Kg</MenuItem>
                                <MenuItem value={2}> Energy in Btu/lb</MenuItem>
                                <MenuItem value={3}> Energy in Btu/barrel</MenuItem>
                                <MenuItem value={4}> Energy in Btu/gallon</MenuItem>
                                <MenuItem value={5}> Energy in kCal/kg </MenuItem>
                            </Select>
                            <BootstrapInput type="number" min="0" value={energyValue} onChange={(e) => onChangeHandler("energyValue", e.target.value < 0 ? (e.target.value = '') : e.target.value)} />
                        </Box>

                        <Box component="div" className="bunkarinput">
                            <Select
                                labelId="outlined-label"
                                className="mr20 bunkerselect custom-style2"
                                value={gravityType}
                                onChange={(e) => onChangeHandler("gravityType", e.target.value)}
                            >
                                <MenuItem value={1}> Density at 15<sup>o</sup>C, Kg/m3</MenuItem>
                                <MenuItem value={3}> API Gravity at 60<sup>o</sup>F, <sup>o</sup>API</MenuItem>
                                <MenuItem value={2}> Specific Gravity at 60/60 <sup>o</sup>F </MenuItem>
                            </Select>

                            <BootstrapInput type="number" value={gravityValue} onChange={(e) => onChangeHandler("gravityValue", e.target.value)} />
                            
                        </Box>
                    </FormControl>

                    <Grid item xs={12} md={12} className="mb25">
                        <button type="reset"
                            className={classes.btn1}
                            onClick={onReset} >Reset</button>
                        <button type="button"
                            className={classes.btn2}
                            onClick={onConvertHandle}>Convert</button>{''}
                         <span className="newerrortext">{errs}</span>
                    </Grid>
                </Grid>
            </Grid>


            <TableContainer component={Paper} className="mt25 mb25">
                <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Energy Unit</StyledTableCell>
                            <StyledTableCell >Value</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Object.keys(calcEnrgyUnits).length > 0 && Object.entries(calcEnrgyUnits).map((row) => (
                            <StyledTableRow key={row[0]}>
                                <StyledTableCell component="th" scope="row">
                                    {EnergyTypes[row[0]]}
                                </StyledTableCell>
                                <StyledTableCell  >{row[1]}</StyledTableCell>

                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}


export default EnergyConversion

